import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LocationProvider } from './contexts/LocationContext';
import Home from './pages/Home';
import CookieConsent from './components/Common/CookieConsent';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <CookieConsent />
          </div>
        </Router>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
